import { Suspense } from 'react';
import * as Sentry from '@sentry/react';
import ReactDOM from 'react-dom/client';
import './apps/main-app/localization/formErrors'; // make sure it's loaded before APP bundle
import './apps/main-app/style/index.css';
import './apps/main-app/localization/i18n.ts';
import InvoiceApp from './apps/invoice-app/InvoiceApp';
import App from './apps/main-app/App';
import { FullSizeLoader } from './apps/main-app/components/FullSizeLoader';
import { getConfig } from './apps/main-app/utils/config';

if (!import.meta.env.DEV) {
  //init sentry only in non DEV environments
  Sentry.init({
    dsn: 'https://1fa3a27cf557473491d8b36a1ac674fa@sentry.argo22.com/69',
    integrations: [new Sentry.BrowserTracing()],
    environment: import.meta.env.MODE,
    tracesSampleRate: 0.75,
    release: import.meta.env.PACKAGE_VERSION,
  });
}

const { invoiceAppUrls } = getConfig();

const root = document.getElementById('root') as HTMLElement;

const renderInvoiceApp = invoiceAppUrls.includes(window.location.host);

ReactDOM.createRoot(root).render(
  <Suspense fallback={<FullSizeLoader />}>{renderInvoiceApp ? <InvoiceApp /> : <App />}</Suspense>,
);
